/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useCallback } from "react";

import * as React from "react";
import { DropzoneInstructions, DropzoneText } from "../Dropzone";
import { PlatformContent } from "./Platforms";
import { SignUpButton } from "components/UseCases/Shared";

const LoggedOutView: React.FC = () => {
  const signIn = useCallback(() => {
    window.adobeIMS?.signIn();
  }, []);

  return (
    <>
      <DropzoneText marginTopPx={0} marginBottomPx={6}>
        {I18n.t("enhance_speech.get_started")}
      </DropzoneText>
      <DropzoneInstructions marginBottomPx={24}>
        {I18n.t("enhance_speech.sign_up_instructions")}
      </DropzoneInstructions>
      <SignUpButton />
      <DropzoneInstructions marginTopPx={24}>
        {`${I18n.t("enhance_speech.already_have_account_instructions")} `}
        <a href="#" onClick={signIn}>
          {I18n.t("enhance_speech.sign_in")}
        </a>
      </DropzoneInstructions>
    </>
  );
};

const LoggedOutContent: React.FC = () => {
  return (
    <PlatformContent>
      <LoggedOutView />
    </PlatformContent>
  );
};

export default LoggedOutContent;
